import type { ComparisonPage } from "./comparison-page.ts";
import { INSTAGRAM_EMAIL_EXTRACTORS_WORDS_EN } from "./instagram-email-extractors-words-en.ts";
import { INSTAGRAM_EMAIL_EXTRACTORS_WORDS_ES } from "./instagram-email-extractors-words-es.ts";

// One entry per comparison page (ADR-034 point 4). A page also needs its literal screen entry in
// `comparisons.web.ts` and its address in the comparisons URL list.
export const COMPARISON_PAGES: readonly ComparisonPage[] = [
  {
    path: "/compare/instagram-email-extractors",
    slug: "instagram-email-extractors",
    words: { en: INSTAGRAM_EMAIL_EXTRACTORS_WORDS_EN, es: INSTAGRAM_EMAIL_EXTRACTORS_WORDS_ES },
  },
];

/** The page at an English address; the screens and the data are held together by a test. */
export function pageOfComparison(path: string): ComparisonPage | undefined {
  return COMPARISON_PAGES.find((page) => page.path === path);
}
